export enum DATA_QA {
  ROOT = 'create-campaign',
  NAME = 'create-campaign__name',
  NAME_INPUT = 'create-campaign__name-input',
  CONTINUE = 'create-campaign__continue',
  VALIDATION_MESSAGE = 'validation-message',
}
